import Box from 'UIKit/Box/Box'
import { ICommonBonus, WageringConditionCommonBonus } from 'config/types/bonus'
import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import styled from 'styled-components'
import SimpleBonusDetails from './SimpleBonusDetails'
import WageringBonusConditionDetails from './WageringBonusConditionDetails'

const StyledContainer = styled(Box)`
  & > * {
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.15;
    font-size: 14px;
  }
  & a {
    color: ${({ theme }) => theme.colors.text};
  }

  word-break: break-word;

  height: 100%;
  overflow-y: auto;
`

const BonusDetailsContent: React.FC<{ bonus: ICommonBonus }> = ({ bonus }) => {
  return (
    <StyledContainer p={['0px 12px', '', '0px 24px']}>
      {bonus instanceof WageringConditionBonus || bonus instanceof WageringConditionCommonBonus ? (
        <WageringBonusConditionDetails bonus={bonus} />
      ) : (
        <SimpleBonusDetails bonus={bonus} />
      )}
    </StyledContainer>
  )
}

export default BonusDetailsContent
